// import { jwtDecode } from "jwt-decode";
// import api from './api';
// import { Preferences } from '@capacitor/preferences';


// // Description: Login user functionality
// // Endpoint: POST /api/auth/login
// // Request: { email: string, password: string }
// // Response: { accessToken: string, refreshToken: string }
// export const login = async (email: string, password: string) => {
//   try {
//     console.log("auth.ts: Making login request for:", email);
//     const formData = new FormData();
//     formData.append('username', email);
//     formData.append('password', password);
//     const response = await api.post('/api/auth/login', formData);
//     console.log("auth.ts: Login response data:", response.data);
//     const user = jwtDecode(response?.data?.access_token);

//     await Preferences.set({ key: "level", value: user?.association?.level?.toString() });
//     await Preferences.set({ key: 'employee_id', value: user?.id });
//     await Preferences.set({ key: "branchID", value: user?.association?.branchID });
//     await Preferences.set({ key: "headOfficeID", value: user?.association?.headOfficeID });
//     await Preferences.set({ key: "masterID", value: user?.association?.masterID });

//     console.log("masterID", await Preferences.get({ key: "masterID" }));
//     console.log("headOfficeId", await Preferences.get({ key: "headOfficeID" }));
//     await Preferences.set({ key: "workfromhome", value: user?.workfromhome });
//     await Preferences.set({ key: "workingHoursStart1", value: user?.wifi_ssid[1]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd1", value: user?.wifi_ssid[1]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance1", value: user?.wifi_ssid[1]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon1", value: user?.wifi_ssid[1]?.longitude });
//     await Preferences.set({ key: "officeLat1", value: user?.wifi_ssid[1]?.lattitude });
//     await Preferences.set({ key: "workingHoursStart2", value: user?.wifi_ssid[2]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd2", value: user?.wifi_ssid[2]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance2", value: user?.wifi_ssid[2]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon2", value: user?.wifi_ssid[2]?.longitude });
//     await Preferences.set({ key: "officeLat2", value: user?.wifi_ssid[2]?.lattitude });
//     await Preferences.set({ key: "workingHoursStart3", value: user?.wifi_ssid[3]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd3", value: user?.wifi_ssid[3]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance3", value: user?.wifi_ssid[3]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon3", value: user?.wifi_ssid[3]?.longitude });
//     await Preferences.set({ key: "officeLat3", value: user?.wifi_ssid[3]?.lattitude });

//     return response.data;
//   } catch (error: any) {
//     console.error('auth.ts: Login error:', error);
//     console.error('auth.ts: Error response:', error?.response?.data);
//     throw new Error(error?.response?.data?.message || error.message);
//   }
// };

// // Description: Register user functionality
// // Endpoint: POST /api/auth/register
// // Request: { email: string, password: string }
// // Response: { email: string }

// export const register = async (email: string, password: string, role: string) => {
//   try {
//     console.log("auth.ts: Making registration request for:", email, "with role:", role);
//     const response = await api.post('/api/auth/register', {
//       email,
//       password,
//       role,
//     });
//     console.log("auth.ts: Registration response data:", response.data);
//     return response.data;
//   } catch (error: any) {
//     console.error('auth.ts: Registration error:', error);
//     console.error('auth.ts: Error response:', error?.response?.data);
//     throw new Error(error?.response?.data?.message || error.message);
//   }
// };


// // Description: Logout
// // Endpoint: POST /api/auth/logout
// // Request: {}
// // Response: { success: boolean, message: string }
// export const logout = async () => {
//   try {
//     console.log("auth.ts: Making logout request");
//     return await api.post('/api/auth/logout');
//   } catch (error: any) {
//     console.error('auth.ts: Logout error:', error);
//     throw new Error(error?.response?.data?.message || error.message);
//   }
// }; 




import { jwtDecode } from "jwt-decode";
import api from './api';
import { Preferences } from '@capacitor/preferences';

// Description: Get organizations by email
// Endpoint: POST /api/auth/get-organizations
// Request: { email: string }
// Response: { success: boolean, organizations: Array<{ head_office_id: string, company_name: string, organization: string }> }
export const getOrganizations = async (email: string) => {
  try {
    console.log("auth.ts: Getting organizations for email:", email);
    const response = await api.post('/api/auth/get-organizations', { email });
    console.log("auth.ts: Organizations response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error('auth.ts: Get organizations error:', error);
    console.error('auth.ts: Error response:', error?.response?.data);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Login with organization selection
// Endpoint: POST /api/auth/login-select
// Request: { email: string, password: string, head_office_id: string }
// Response: { access_token: string, token_type: string }
export const loginSelect = async (email: string, password: string, head_office_id: string) => {
  try {
    console.log("auth.ts: Making login-select request for:", email, "with head_office_id:", head_office_id);
    const response = await api.post('/api/auth/login-select', {
      email,
      password,
      head_office_id
    });
    console.log("auth.ts: Login-select response data:", response.data);
    
    const { access_token } = response.data;
    
    if (access_token) {
      // Decode the JWT token to get user information
      const user: any = jwtDecode(access_token);
      console.log("auth.ts: Decoded user from token:", user);
      
      // Store token
      await Preferences.set({ key: 'access_token', value: access_token });
      
      // Store user information from decoded token
      await Preferences.set({ key: "level", value: user?.association?.level?.toString() });
      await Preferences.set({ key: 'employee_id', value: user?.id });
      await Preferences.set({ key: "branchID", value: user?.association?.branchID });
      await Preferences.set({ key: "headOfficeID", value: user?.association?.headOfficeID });
      await Preferences.set({ key: "masterID", value: user?.association?.masterID });
      await Preferences.set({ key: "email", value: email });
      await Preferences.set({ key: "company_name", value: user?.company_name });
      
      console.log("auth.ts: Stored masterID:", await Preferences.get({ key: "masterID" }));
      console.log("auth.ts: Stored headOfficeID:", await Preferences.get({ key: "headOfficeID" }));
      
      // Store work location settings if available
      await Preferences.set({ key: "workfromhome", value: user?.workfromhome?.toString() });
      
      // Store WiFi/Office location settings (supports up to 3 locations)
      if (user?.wifi_ssid) {
        for (let i = 1; i <= 3; i++) {
          if (user.wifi_ssid[i]) {
            await Preferences.set({ key: `workingHoursStart${i}`, value: user.wifi_ssid[i]?.working_hours_start });
            await Preferences.set({ key: `workingHoursEnd${i}`, value: user.wifi_ssid[i]?.working_hours_end });
            await Preferences.set({ key: `maxDistance${i}`, value: user.wifi_ssid[i]?.radius_meters?.toString() });
            await Preferences.set({ key: `officeLon${i}`, value: user.wifi_ssid[i]?.longitude });
            await Preferences.set({ key: `officeLat${i}`, value: user.wifi_ssid[i]?.lattitude });
          }
        }
      }
    }
    
    return response.data;
  } catch (error: any) {
    console.error('auth.ts: Login-select error:', error);
    console.error('auth.ts: Error response:', error?.response?.data);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Legacy login (kept for backward compatibility)
// Endpoint: POST /api/auth/login
// Request: { email: string, password: string }
// Response: { accessToken: string, refreshToken: string }
// export const login = async (email: string, password: string) => {
//   try {
//     console.log("auth.ts: Making login request for:", email);
//     const formData = new FormData();
//     formData.append('username', email);
//     formData.append('password', password);
//     const response = await api.post('/api/auth/login', formData);
//     console.log("auth.ts: Login response data:", response.data);
//     const user = jwtDecode(response?.data?.access_token);

//     await Preferences.set({ key: "level", value: user?.association?.level?.toString() });
//     await Preferences.set({ key: 'employee_id', value: user?.id });
//     await Preferences.set({ key: "branchID", value: user?.association?.branchID });
//     await Preferences.set({ key: "headOfficeID", value: user?.association?.headOfficeID });
//     await Preferences.set({ key: "masterID", value: user?.association?.masterID });

//     console.log("masterID", await Preferences.get({ key: "masterID" }));
//     console.log("headOfficeId", await Preferences.get({ key: "headOfficeID" }));
//     await Preferences.set({ key: "workfromhome", value: user?.workfromhome });
//     await Preferences.set({ key: "workingHoursStart1", value: user?.wifi_ssid[1]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd1", value: user?.wifi_ssid[1]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance1", value: user?.wifi_ssid[1]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon1", value: user?.wifi_ssid[1]?.longitude });
//     await Preferences.set({ key: "officeLat1", value: user?.wifi_ssid[1]?.lattitude });
//     await Preferences.set({ key: "workingHoursStart2", value: user?.wifi_ssid[2]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd2", value: user?.wifi_ssid[2]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance2", value: user?.wifi_ssid[2]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon2", value: user?.wifi_ssid[2]?.longitude });
//     await Preferences.set({ key: "officeLat2", value: user?.wifi_ssid[2]?.lattitude });
//     await Preferences.set({ key: "workingHoursStart3", value: user?.wifi_ssid[3]?.working_hours_start });
//     await Preferences.set({ key: "workingHoursEnd3", value: user?.wifi_ssid[3]?.working_hours_end });
//     await Preferences.set({ key: "maxDistance3", value: user?.wifi_ssid[3]?.radius_meters?.toString() });
//     await Preferences.set({ key: "officeLon3", value: user?.wifi_ssid[3]?.longitude });
//     await Preferences.set({ key: "officeLat3", value: user?.wifi_ssid[3]?.lattitude });

//     return response.data;
//   } catch (error: any) {
//     console.error('auth.ts: Login error:', error);
//     console.error('auth.ts: Error response:', error?.response?.data);
//     throw new Error(error?.response?.data?.detail || error.message);
//   }
// };

// Description: Register user functionality
// Endpoint: POST /api/auth/register
// Request: { email: string, password: string, role: string }
// Response: { email: string }
export const register = async (email: string, password: string, role: string, first_name: string, last_name: string) => {
  try {
    console.log("auth.ts: Making registration request for:", email, "with role:", role);
    const response = await api.post('/api/auth/register', {
      email,
      password,
      role,
      first_name,
      last_name
    });
    console.log("auth.ts: Registration response data:", response.data);
    return response.data;
  } catch (error: any) {
    console.error('auth.ts: Registration error:', error);
    console.error('auth.ts: Error response:', error?.response?.data);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Logout
// Endpoint: POST /api/auth/logout
// Request: {}
// Response: { success: boolean, message: string }
export const logout = async () => {
  try {
    console.log("auth.ts: Making logout request");
    // Clear all stored preferences
    await Preferences.remove({ key: 'access_token' });
    await Preferences.remove({ key: 'employee_id' });
    await Preferences.remove({ key: 'level' });
    await Preferences.remove({ key: 'branchID' });
    await Preferences.remove({ key: 'headOfficeID' });
    await Preferences.remove({ key: 'masterID' });
    await Preferences.remove({ key: 'email' });
    await Preferences.remove({ key: 'company_name' });
    await Preferences.remove({ key: 'workfromhome' });
    
    // Clear location settings
    for (let i = 1; i <= 3; i++) {
      await Preferences.remove({ key: `workingHoursStart${i}` });
      await Preferences.remove({ key: `workingHoursEnd${i}` });
      await Preferences.remove({ key: `maxDistance${i}` });
      await Preferences.remove({ key: `officeLon${i}` });
      await Preferences.remove({ key: `officeLat${i}` });
    }
    
    return await api.post('/api/auth/logout');
  } catch (error: any) {
    console.error('auth.ts: Logout error:', error);
    throw new Error(error?.response?.data?.detail || error.message);
  }
};

// Description: Check if user is authenticated
// Endpoint: N/A
// Request: N/A
// Response: boolean
export const isAuthenticated = async (): Promise<boolean> => {
  try {
    const token = await Preferences.get({ key: 'access_token' });
    if (!token.value) return false;
    
    // Check if token is expired
    const decoded: any = jwtDecode(token.value);
    const currentTime = Date.now() / 1000;
    
    if (decoded.exp && decoded.exp < currentTime) {
      // Token expired
      await logout();
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('auth.ts: Auth check error:', error);
    return false;
  }
};

// Description: Get current user
// Endpoint: N/A
// Request: N/A
// Response: User object or null
export const getCurrentUser = async () => {
  try {
    const token = await Preferences.get({ key: 'access_token' });
    if (!token.value) return null;
    
    const user: any = jwtDecode(token.value);
    return user;
  } catch (error) {
    console.error('auth.ts: Get current user error:', error);
    return null;
  }
};